import { I18n } from 'src/translations/i18n';
import { getFormValues, destroy } from 'redux-form';

import {
  evolve, lensPath, merge,
  pathOr, path, compose, omit,
  values, keys, set, prop, over, assoc
} from 'ramda';
import { requestEvolve, failEvolve, successEvolve } from './reducerUtill';

export const paragraphForm = 'PARAGRAPH_FORM';

// Actions
export const lawsActions = {
  request: 'LAWS_REQUEST',
  success: 'LAWS_SUCCESS',
  fail: 'LAWS_FAIL',
  activeChange: 'LAW_ACTIVE_CHANGE'
};

export const paragraphsActions = {
  request: 'LAW_PARAGRAPHS_REQUEST',
  success: 'LAW_PARAGRAPHS_SUCCESS',
  fail: 'LAW_PARAGRAPHS_FAIL',
  activeChange: 'LAW_PARAGRAPH_ACTIVE_CHANGE',
  optionsSuccess: 'LAW_PARAGRAPH_OPTIONS_SUCCESS'
};

export const userParagrapghsActions = {
  request: 'LAW_USER_PARAGRAPHS_REQUEST',
  success: 'LAW_USER_PARAGRAPHS_SUCCESS',
  fail: 'LAW_USER_PARAGRAPHS_FAIL',
  activeChange: 'LAW_USER_PARAGRAPH_ACTIVE_CHANGE'
};

export const userParagraphActions = {
  create: {
    request: 'LAW_PARAGRAPH_CREATE_REQUEST',
    success: 'LAW_PARAGRAPH_CREATE_SUCCESS',
    fail: 'LAW_PARAGRAPH_CREATE_FAIL'
  },
  update: {
    request: 'LAW_PARAGRAPH_UPDATE_REQUEST',
    success: 'LAW_PARAGRAPH_UPDATE_SUCCESS',
    fail: 'LAW_PARAGRAPH_UPDATE_FAIL'
  },
  delete: {
    request: 'LAW_PARAGRAPH_DELETE_REQUEST',
    success: 'LAW_PARAGRAPH_DELETE_SUCCESS',
    fail: 'LAW_PARAGRAPH_DELETE_FAIL'
  }
};

// Action creators
export const lawsRequest = () => (dispatch) => dispatch({ type: lawsActions.request });

export const lawChange = (lawId) => (dispatch) => dispatch({
  type: lawsActions.activeChange,
  payload: lawId
});
export const paragraphChange = (paragraphId) => (dispatch) => dispatch({
  type: paragraphsActions.activeChange,
  payload: paragraphId
});
export const userParagraphChange = (userParagraphId) => (dispatch) => dispatch({
  type: userParagrapghsActions.activeChange,
  payload: userParagraphId
});

export const userParagrapUpdate = () => (dispatch) => dispatch({ type: userParagraphActions.update.request });
export const userParagrapDelete = () => (dispatch) => dispatch({ type: userParagraphActions.delete.request });

export const paragraphFormClear = () => (dispatch) => dispatch(destroy(paragraphForm));

// Selectors
export const getParagraphFormValues = getFormValues(paragraphForm);

export const nameIdToOption = (obj) => values(obj).map((item) => ({
  label: item.name,
  value: item.id.toString(),
  item
}));

export const i18nameIdToOption = (obj) => values(obj).map((item) => ({
  label: I18n.t(item.name),
  value: item.id.toString(),
  item
}));

export const getLawRoot = pathOr({}, ['law']);

export const getLawId = compose(path(['activeLaw']), getLawRoot);
export const getParagraphId = compose(path(['activeParagraph']), getLawRoot);
export const getUserParagraphId = compose(path(['activeUserParagraph']), getLawRoot);

export const getLaws = compose(pathOr({}, ['list']), getLawRoot);

export const getParagraphs = (store) => {
  const lawId = getLawId(store);
  return compose(
    pathOr({}, [lawId, 'paragraphs']),
    getLaws
  )(store);
};
export const getParagraph = (store) => {
  const paragraphId = getParagraphId(store);
  return compose(
    pathOr({}, [paragraphId]),
    getParagraphs
  )(store);
};
export const getUserParagraphs = (store) => {
  const lawId = getLawId(store);

  return compose(
    pathOr({}, [lawId, 'userParagraphs']),
    getLaws
  )(store);
};


// Reducer
const initialState = {
  list: {
    '-1': {
      id: -1,
      name: 'loading',
      paragraphs: {
        '-1': {}
      },
      userParagraphs: {
        '-1': {}
      }
    }
  },
  activeLaw: null,
  activeParagraph: null,
  activeUserParagraph: null,
  pending: true,
  error: null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case lawsActions.request:
      return evolve(requestEvolve, state);
    case lawsActions.fail:
      return evolve(failEvolve(payload), state);
    case lawsActions.success:
      return compose(
        evolve(successEvolve),
        set(lensPath(['list']), payload)
      )(state);
    case (paragraphsActions.success):
      return keys(payload).reduce((acc, lawId) => set(lensPath(['list', lawId, 'paragraphs']), prop(lawId, payload), acc), state);
    case (userParagrapghsActions.success):
      return keys(payload).reduce((acc, lawId) => set(lensPath(['list', lawId, 'userParagraphs']), prop(lawId, payload), acc), state);
    case paragraphsActions.optionsSuccess:
      return set(lensPath(['list', payload.lawId, 'paragraphs', payload.paragraphId, 'options']), payload.options, state);
    case userParagraphActions.create.success:
    case userParagraphActions.update.success:
      return merge(
        set(lensPath(['list', payload.lawId, 'userParagraphs', payload.id]), payload, state),
        { activeUserParagraph: payload.id.toString() }
      );
    case userParagraphActions.delete.success:
      return over(lensPath(['list', payload.lawId, 'userParagraphs']), omit([payload.id]), state);
    case lawsActions.activeChange:
      return compose(
        assoc('activeUserParagraph', null),
        assoc('activeParagraph', null),
        assoc('activeLaw', payload)
      )(state);
    case paragraphsActions.activeChange:
      return compose(
        assoc('activeUserParagraph', null),
        assoc('activeParagraph', payload)
      )(state);
    case userParagrapghsActions.activeChange:
      return assoc('activeUserParagraph', payload)(state);
    default: {
      return state;
    }
  }
};
